"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputMultiselect = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_select_1 = __importDefault(require("react-select"));
class InputMultiselect extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.onValueChange = this.onValueChange.bind(this);
    }
    onValueChange(valuesArray) {
        if (valuesArray) {
            if (this.props.multiple !== false) {
                if (!Array.isArray(valuesArray)) {
                    valuesArray = [valuesArray];
                }
                this.props.onValueChange({ target: { value: valuesArray.map((option) => option.value) } });
            }
            else {
                this.props.onValueChange({ target: { value: valuesArray.value } });
            }
        }
        else {
            this.props.onValueChange({ target: { value: [] } });
        }
    }
    render() {
        const actualValue = this.props.value.length === 0 ? this.props.defaultValue : this.props.value || [];
        const defaultAttributes = {
            autoComplete: 'none',
            className: 'tr__form-input-multiselect apptr__input _input-multiselect',
            name: this.props.id,
            id: this.props.id,
            value: actualValue
        };
        if (this.props.onValueChange) {
            defaultAttributes.onChange = this.props.onValueChange;
        }
        if (this.props.disabled === true) {
            defaultAttributes.disabled = true;
            defaultAttributes.isDisabled = true;
        }
        const actualValueWithLabel = [];
        const choices = this.props.choices;
        const t = this.props.t;
        const localePrefix = this.props.localePrefix || 'main';
        const selectOptions = choices.map((choice) => {
            const label = choice.label || t(`${localePrefix}:${choice.value}`);
            if (actualValue.indexOf(choice.value) > -1) {
                actualValueWithLabel.push({
                    label: label,
                    //color: choice.color,
                    value: choice.value,
                    index: actualValue.indexOf(choice.value)
                });
            }
            return {
                label: label,
                //color: choice.color,
                value: choice.value
            };
        });
        actualValueWithLabel.sort((valueObjectA, valueObjectB) => {
            return valueObjectA.index - valueObjectB.index;
        });
        const customStyles = {
            control: (base, _state) => (Object.assign(Object.assign({}, base), { backgroundColor: 'rgba(0,0,0,1.0)', 
                /*height: '3rem',
        minHeight: '3rem',
        padding: '0.1rem',*/
                borderColor: 'rgba(255,255,255,0.1)' })),
            multiValue: (base, _state) => (Object.assign(Object.assign({}, base), { backgroundColor: 'rgba(255,255,255,0.2)' })),
            multiValueLabel: (base, _state) => (Object.assign(Object.assign({}, base), { color: 'rgba(255,255,255,0.8)' })),
            input: (base, state) => (Object.assign(Object.assign({}, base), { backgroundColor: state.isFocused ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.0)' })),
            placeholder: (base, state) => (Object.assign(Object.assign({}, base), { backgroundColor: state.isFocused ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.0)' })),
            option: (base, state) => (Object.assign(Object.assign({}, base), { padding: '0.25rem 0.5rem', color: 'rgba(255,255,255,1.0)', backgroundColor: state.isFocused ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.0)' })),
            menu: (base, _state) => (Object.assign(Object.assign({}, base), { zIndex: 1000, marginTop: '0', backgroundColor: 'rgba(0,0,0,1.0)' }))
        };
        return (react_1.default.createElement("div", { className: "tr__form-input-multiselect" },
            react_1.default.createElement(react_select_1.default, Object.assign({}, defaultAttributes, { menuPortalTarget: document.querySelector('body'), isMulti: this.props.multiple !== false, onChange: this.onValueChange, options: selectOptions, isSearchable: true, isClearable: this.props.isClearable || true, closeMenuOnSelect: this.props.closeMenuOnSelect || (this.props.multiple ? false : true), placeholder: "", value: (this.props.multiple !== false ? actualValueWithLabel : actualValueWithLabel[0]), className: "react-select-container apptr__input _input-multiselect", classNamePrefix: "react-select", styles: customStyles }))));
    }
}
exports.InputMultiselect = InputMultiselect;
InputMultiselect.defaultProps = {
    value: [],
    defaultValue: [],
    choices: [],
    multiple: true,
    localePrefix: 'main',
    t: (_str) => '',
    disabled: false
};
exports.default = InputMultiselect;
//# sourceMappingURL=InputMultiselect.js.map